import { ComponentProps, ComponentType, FC, ReactNode } from 'react'

interface Props {
  icon: ComponentType<ComponentProps<'svg'>>
  title: ReactNode
}

export const EmptyState: FC<Props> = ({ title, icon: Icon }) => {
  return (
    <div className="relative block w-full p-12 text-center bg-background-muted">
      <Icon aria-hidden className="mx-auto h-12 w-12 text-gray-300" />
      <span className="mt-2 block text-sm font-medium text-gray-500">{title}</span>
    </div>
  )
}
